import React from 'react';
import { Wrench } from 'lucide-react';

export const Installation = () => {
  return (
    <div className="space-y-6" data-testid="installation-page">
      <div className="hidden lg:flex items-center gap-3">
        <div className="p-2 rounded-lg bg-[#2563eb]/10">
          <Wrench className="w-6 h-6 text-[#2563eb]" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-foreground">Installation</h1>
          <p className="text-sm text-muted-foreground">Device installation and fitter management</p>
        </div>
      </div>

      <div className="flex items-center justify-center h-[60vh] border border-dashed border-border rounded-lg">
        <div className="text-center space-y-2">
          <Wrench className="w-12 h-12 text-muted-foreground mx-auto" />
          <p className="text-muted-foreground text-sm">Installation features coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default Installation;
